import { NavItem } from 'react-bootstrap'
import { InverseNavWrapper } from '../../styles';
import { LinkContainer } from 'react-router-bootstrap';

export enum PatientIntakeTabs {
    TO_DO = 'TO-DO',
    PENDING_ORDERS = 'PENDING_ORDERS',
    PENDING_RECIPIENT_PROFILE = 'PENDING_RECIPIENT_PROFILE',
    COMPLETED = 'COMPLETED',
    ALL = 'ALL'
}

export const patientIntakeTabs = [
    { key: PatientIntakeTabs.TO_DO, label: 'TO-DO', url: 'to-do' },
    { key: PatientIntakeTabs.PENDING_ORDERS, label: 'Pending Labs', url: 'pending-orders' },
    { key: PatientIntakeTabs.PENDING_RECIPIENT_PROFILE, label: 'Pending Recipient Profile', url: 'pending-recipient-profile' },
    { key: PatientIntakeTabs.COMPLETED, label: 'Completed', url: 'completed' },
    { key: PatientIntakeTabs.ALL, label: 'All', url: 'all' }
]

interface IProps {
    centerId: number
    tab: string,
    isAdmin: boolean
}

const PassNav = (props: IProps) => {
    let url = props.isAdmin ? '/admin/patient-intake' : `/center/${props.centerId}/recipients/patient-intake`;

    return (
        <InverseNavWrapper bsStyle='tabs' activeKey={props.tab}>
            {patientIntakeTabs.map(tab =>
                <LinkContainer key={'tab-' + tab.key} active={props.tab == tab.key} to={`${url}/${tab.url}`}>
                    <NavItem eventKey={tab.key}>{tab.label}</NavItem>
                </LinkContainer>
            )}
        </InverseNavWrapper>
    );
}

export default PassNav;